export const WHOLE_NUMBER_OPTIONS = { minimumFractionDigits: 0, maximumFractionDigits: 0 };

export const currency = (amount: number, options?: Intl.NumberFormatOptions) =>
  amount.toLocaleString('en', { ...options, style: 'currency', currency: 'USD' });
